module.exports = __webpack_public_path__ + "img/Jay Mitchell.00152d8b.jpg";